
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";




// // /**
// //  * Tạo ngôn ngữ cần phiên dịch mới
// //  * @param {Object} data - Dữ liệu ngôn ngữ mới, bao gồm:
// //  *   - code: Mã ngôn ngữ (ví dụ: 'en', 'vi')
// //  *   - name: Tên ngôn ngữ (ví dụ: 'English', 'Tiếng Việt')
// //  *   - flag: Mã quốc kỳ (ví dụ: 'us' cho Mỹ, 'vn' cho Việt Nam)
// //  * @returns {Promise<Object>}
// //  */
// // export const createLanguage = async (data) => {
// //     try {
// //         const response = await axios.post(API_ENDPOINTS.LANGUAGES.CREATE, data);
// //         console.log("Tạo ngôn ngữ thành công:", response.data);
// //         return response.data;
// //     } catch (error) {
// //         console.error("Lỗi khi tạo ngôn ngữ:", error);
// //         throw error;
// //     }
// // };


// /**
//  * Lấy tất cả ngôn ngữ đang hoạt động
//  * @returns {Promise<Object>}
//  */
// export const getActiveLanguages = async () => {
//     try {
//         const response = await axiosInstance.get(API_ENDPOINTS.LANGUAGES.GET_ACTIVE);
//         console.log("Kết quả lấy tất cả ngôn ngữ đang hoạt động:", response.data);

//         // Xử lý nhiều format response khác nhau
//         const data = response.data;

//         // Nếu response có cấu trúc { success, data }
//         if (data && typeof data === 'object' && 'success' in data) {
//             return data;
//         }

//         // Nếu response là array trực tiếp (danh sách ngôn ngữ)
//         if (Array.isArray(data)) {
//             return {
//                 success: true,
//                 data: data
//             };
//         }

//         // Nếu response có 'data' field
//         if (data && data.data) {
//             return {
//                 success: true,
//                 data: data.data
//             };
//         }

//         // Fallback - return toàn bộ response
//         return data;
//     } catch (error) {
//         console.error("Lỗi khi lấy tất cả ngôn ngữ đang hoạt động:", error);
//         console.error("Thông tin chi tiết lỗi:", {
//             message: error.message,
//             status: error.response?.status,
//             data: error.response?.data,
//             url: error.config?.url
//         });
//         throw error;
//     }
// };


// /**
//  * Lấy ngôn ngữ theo ID
//  * @param {string | number} id - ID của ngôn ngữ cần lấy
//  * @returns {Promise<Object>}
//  */
// export const getLanguageById = async (id) => {
//     try {
//         const response = await axios.get(API_ENDPOINTS.LANGUAGES.GET_BY_ID(id));
//         console.log("Kết quả lấy ngôn ngữ theo ID:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("Lỗi khi lấy ngôn ngữ theo ID:", error);
//         throw error;
//     }
// };


// /**
//  * Cập nhật ngôn ngữ
//  * @param {string | number} id - ID của ngôn ngữ cần cập nhật 
//  * @param {Object} data - Dữ liệu cập nhật
//  * @returns {Promise<Object>}
//  */
// export const updateLanguage = async (id, data) => {
//     try {
//         const response = await axios.put(API_ENDPOINTS.LANGUAGES.UPDATE(id), data);
//         console.log("Cập nhật ngôn ngữ thành công:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("Lỗi khi cập nhật ngôn ngữ:", error);
//         throw error;
//     }
// };

// /**
//  * Xóa ngôn ngữ
//  * @param {string | number} id - ID của ngôn ngữ cần xóa
//  * @returns {Promise<Object>}
//  */
// export const deleteLanguage = async (id) => {
//     try {
//         const response = await axios.delete(API_ENDPOINTS.LANGUAGES.DELETE(id));
//         console.log("Xóa ngôn ngữ thành công:", response.data);
//         return response.data;
//     } catch (error) {
//         console.error("Lỗi khi xóa ngôn ngữ:", error);
//         throw error;
//     }
// };


// export const getLanguages = async (params) => {
//     const response = await axiosInstance.get(API_ENDPOINTS.ADMIN_LANGUAGES, { params });
//     return response.data;
// };

// export const getLanguageById = async (id) => {
//     const response = await axiosInstance.get(`${API_ENDPOINTS.ADMIN_LANGUAGES}/${id}`);
//     return response.data;
// };

// export const createLanguage = async (data) => {
//     const response = await axiosInstance.post(API_ENDPOINTS.ADMIN_LANGUAGES, data);
//     return response.data;
// };

// export const updateLanguage = async (id, data) => {
//     const response = await axiosInstance.put(`${API_ENDPOINTS.ADMIN_LANGUAGES}/${id}`, data);
//     return response.data;
// };

// export const deleteLanguage = async (id) => {
//     const response = await axiosInstance.delete(`${API_ENDPOINTS.ADMIN_LANGUAGES}/${id}`);
//     return response.data;
// };

// export const getActiveLanguages = async () => {
//     const response = await axiosInstance.get(API_ENDPOINTS.PUBLIC_ACTIVE_LANGUAGES);
//     return response.data;
// };


export const getLanguages = async (params) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LANGUAGES.GET_ALL, { params });
    return response.data;
};

export const getLanguageById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.LANGUAGES.GET_BY_ID(id));
    return response.data;
};

export const createLanguage = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.LANGUAGES.CREATE, data);
    return response.data;
};

export const updateLanguage = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.LANGUAGES.UPDATE(id), data);
    return response.data;
};

export const deleteLanguage = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.LANGUAGES.DELETE(id));
    return response.data;
};

export const getActiveLanguages = async () => {
    const response = await axiosInstance.get(API_ENDPOINTS.LANGUAGES.GET_ACTIVE);
    const activeLanguages = response.data?.success ? response.data.data || [] : [];

    // The Admin forms must always be able to enter the English translation when
    // that language has already been configured, even if it is temporarily not
    // enabled on the public site.  The public endpoint intentionally excludes
    // inactive languages, so enrich its result with the existing English record
    // from the authenticated Admin endpoint instead of inventing a languageId.
    if (activeLanguages.some((language) => language.code?.toLowerCase() === 'en')) {
        return response.data;
    }

    try {
        const adminResponse = await axiosInstance.get(API_ENDPOINTS.ADMIN.LANGUAGES.GET_ALL, {
            params: { pageNumber: 1, pageSize: 100 },
        });
        const allLanguages = adminResponse.data?.data?.items || [];
        const englishLanguage = allLanguages.find((language) => language.code?.toLowerCase() === 'en');

        if (englishLanguage) {
            return {
                ...response.data,
                data: [...activeLanguages, englishLanguage],
            };
        }
    } catch {
        // Keep the public-language result when the current account cannot read
        // the Admin language endpoint. The existing Vietnamese workflow remains usable.
    }

    return response.data;
};
